import { ConsentAccessLevel } from '@/api/generated';
import type { AccessLevel } from './types';

export const LOGIN_PATH = '/idp/login';

export const MCP_SCOPE_PREFIX = 'mcp:';

export const SESSION_ERROR_MESSAGE =
  'Your sign-in session has expired. Please start over from the application.';
export const DECISION_ERROR_MESSAGE =
  'Something went wrong applying your decision. Please try again.';
export const SWITCH_ERROR_MESSAGE =
  "Couldn't switch account. Please try again.";
export const LOAD_ERROR_MESSAGE =
  "Couldn't load the consent request. Please try again.";

// The tier the user picks becomes the token's consented scope; the gateway (OPA)
// still narrows the effective scope by the user's role per call.
export const ACCESS_LEVEL_COPY: Record<
  AccessLevel,
  { label: string; allowLabel: string; description: string }
> = {
  [ConsentAccessLevel.level.READ]: {
    label: 'Read only',
    allowLabel: 'Allow read only access',
    description:
      'Can view users, groups, and authenticators covered by this role. Cannot make changes.',
  },
  [ConsentAccessLevel.level.FULL]: {
    label: 'Full access',
    allowLabel: 'Allow full access',
    description:
      'Can view and make changes to users, groups, and authenticators covered by this role.',
  },
};
